import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-jouve-warning-modal-component',
    templateUrl: './jouve-warning-modal.component.html',
    styleUrls: [],
})
export class JouveWarningModalComponent {
    @Input() visibility: boolean;
    @Input() errorKey = 'NC';
    @Output() visibilityChange: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() sendDocument: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() rescanDocument: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    closeModal(): void {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
    }

    handleDocumentSend(): void {
        this.sendDocument.emit(true);
    }

    handleDocumentRescan(): void {
        this.rescanDocument.emit(true);
    }
}
